<template lang="html">
    <a class="btn"><slot>{{btnLabel}}</slot></a>

</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'ctrl-button',
})
export default class PayoutFormControlButton extends Vue {
    @Prop({ default: 'Кнопка' })
    btnLabel!: string
}
</script>

<style scoped lang="less">

</style>
